import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { ComponentProps } from 'react';
import { Link as RRLink, useHref, useLinkClickHandler } from 'react-router-dom';

type Props = Omit<ComponentProps<typeof Button> & ComponentProps<typeof RRLink>, 'href'>;

export const RouteButton = ({ className, onClick, replace = false, state = null, target = '', to, ...rest }: Props) => {
    const href = useHref(to);
    const handleClick = useLinkClickHandler<HTMLButtonElement>(to, {
        replace,
        state,
        target,
    });

    return (
        <Button
            as="a"
            className={cn('no-underline', className)}
            href={href}
            onClick={(event) => {
                onClick?.(event);
                if (!event.defaultPrevented) {
                    handleClick(event);
                }
            }}
            target={target}
            {...rest}
        />
    );
};

export const ExternalRouteButton = ({ className, rel = 'nofollow', to, ...rest }: Props) => (
    <Button
        as="a"
        className={cn('no-underline', className)}
        href={to as string}
        rel={rel}
        {...rest}
    />
);
